<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="text-h5 blue darken-3 white--text">
          Cambiar estado de la inscripción
        </v-card-title>

        <v-card-text>
          <v-divider class="my-2"></v-divider>
          
          <!-- Información de la inscripción actual -->
          <v-alert v-if="inscripcionActual" type="info" dense class="mb-4">
            <div class="d-flex align-center">
              <v-icon small class="mr-2">mdi-account</v-icon>
              <span><strong>Estudiante:</strong> {{nombre_completo()}}</span>
            </div>
            <div class="d-flex align-center mt-1">
              <v-icon small class="mr-2">mdi-school</v-icon>
              <span><strong>Estado actual:</strong> {{ obtenerNombreEstado(inscripcionActual.estado_ins) }}</span>
            </div>
          </v-alert>
          
          <v-radio-group v-model="xestado" class="text-left mt-4">
            <v-radio 
              v-for="n in xestados" 
              :key="n.id" 
              :label="n.text" 
              :value="n"
              class="my-1"
            >
              <template v-slot:label>
                <span :class="{ 'font-weight-bold primary--text': n.id === xestado?.id }">
                  {{ n.text }}
                </span>
              </template>
            </v-radio>
          </v-radio-group>
          
          <p v-if="msgError" class="text-center red--text mt-2 mb-0">
            <v-icon small color="red">mdi-alert</v-icon> {{ msgError }}
          </p>
          <p v-if="msgSuccess" class="text-center green--text mt-2 mb-0">
            <v-icon small color="green">mdi-check-circle</v-icon> {{ msgSuccess }}
          </p>
          
          <v-divider class="my-3"></v-divider>
          
          <v-progress-linear v-if="loading" indeterminate color="indigo"></v-progress-linear>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrarDialog()" :disabled="loading">
            Cancelar
          </v-btn>
          <v-btn 
            color="primary" 
            :disabled="!puedeGuardar || loading" 
            @click="enviar()"
            :loading="loading"
          >
            <v-icon left>mdi-content-save</v-icon>
            Guardar Cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import xaxios from '@/xaxios';

export default {
  name: 'DialogCambioEstado',
  data() {
    return {
      dialog: false,
      loading: false,
      idins: null,
      inscripcionActual: null,
      xestado: null,
      xestados: [
        { id: 1, text: 'Prospecto' },
        { id: 2, text: 'Preinscrito' },
        { id: 3, text: 'Inscrito' },
        { id: 4, text: 'Inscrito Transferido' },
        { id: 5, text: 'Retirado' },
        { id: 6, text: 'Retirado Cambiado' },
        { id: 7, text: 'Observado' },
      ],
      msgError: '',
      msgSuccess: '',
    };
  },
  computed: {
    puedeGuardar() {
      // Solo permite guardar si se seleccionó un estado diferente al actual
      if (!this.inscripcionActual || !this.xestado) return false;
      return this.xestado.id !== this.inscripcionActual.estado_ins;
    },
    estadoActualNombre() {
      if (!this.inscripcionActual) return '';
      return this.obtenerNombreEstado(this.inscripcionActual.estado_ins);
    },
    
  },
  methods: {
    openmodal(inscripcion) {
      this.resetearDialog();
      this.idins = inscripcion.id;
      this.inscripcionActual = { ...inscripcion };
      window.console.log('Inscripción actual:', this.inscripcionActual);
      window.console.log('estado administratovo_id:', inscripcion.estado_administrativo_id);
      
      // Establecer el estado actual por defecto
      const estadoActual = this.xestados.find(e => e.id === inscripcion.estado_administrativo_id);

      this.xestado = estadoActual || null;
      
      this.dialog = true;
    },
    nombre_completo() {
      if (!this.inscripcionActual || !this.inscripcionActual.estudiante) return '';
      const est = this.inscripcionActual.estudiante;
      return `${est.nombres}  ${est.pri_apellido} ${est.seg_apellido || ''}`.replace(/\s+/g, ' ').trim();
    },

    
    obtenerNombreEstado(idEstado) {
      const estado = this.xestados.find(e => e.id === idEstado);
      return estado ? estado.text : 'Desconocido';
    },
    
    async enviar() {
      if (!this.puedeGuardar) {
        this.msgError = 'Debes seleccionar un estado diferente al actual';
        return;
      }
      
      this.msgError = '';
      this.msgSuccess = '';
      this.loading = true;
      
      try {
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${this.idins}/estado_administrativo`;
        const data = { estado_ins: this.xestado.id };
        
        const response = await xaxios.patch(url, data);
        
        
        // Éxito - emitir evento al padre
        this.msgSuccess = response.data.data || 'Estado actualizado correctamente';
        
        // Emitir evento al componente padre
        this.$emit('estado-cambiado', {
          success: true,
          message: this.msgSuccess,
          inscripcionId: this.idins,
          estadoAnterior: this.inscripcionActual.estado_administrativo_id,
          estadoNuevo: this.xestado.id,
          nombreEstadoNuevo: this.xestado.text,
        });
        
        // Cerrar automáticamente después de 2 segundos
        setTimeout(() => {
          this.cerrarDialog();
        }, 500);
        
      } catch (error) {
        window.console.error('Error al cambiar estado:', error);
        
        let mensajeError = 'Error al cambiar el estado';
        if (error.response) {
          mensajeError = error.response.data?.message || error.response.statusText;
        } else if (error.request) {
          mensajeError = 'Error de conexión con el servidor';
        }
        
        this.msgError = mensajeError;
        
        // Emitir evento de error al padre
        this.$emit('estado-cambiado', {
          success: false,
          message: mensajeError,
          inscripcionId: this.idins,
          error: error,
        });
        
      } finally {
        this.loading = false;
      }
    },
    
    cerrarDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.resetearDialog();
      }, 300);
    },
    
    resetearDialog() {
      this.loading = false;
      this.idins = null;
      this.inscripcionActual = null;
      this.xestado = null;
      this.msgError = '';
      this.msgSuccess = '';
    },
  },
  
  watch: {
    xestado(newVal, oldVal) {
      // Limpiar mensajes cuando se cambia la selección
      if (newVal !== oldVal) {
        this.msgError = '';
        this.msgSuccess = '';
      }
    },
  },
};
</script>

<style scoped>
.v-alert {
  border-left: 4px solid #2196F3;
}

.v-radio {
  border-radius: 4px;
  padding: 4px 8px;
  transition: background-color 0.3s;
}

.v-radio:hover {
  background-color: #f5f5f5;
}
</style>